import * as React from "react";
import { forwardRef } from "react";
const SvgIcChevronLight16 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.83984 8.03033L5 4.31064L6.31068 3L10.8407 7.53034V8.59098L6.31068 13.1213L5 11.8107L8.83984 8.03033Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcChevronLight16);
export { ForwardRef as ReactComponent };
